import React from 'react';
import styles from './styles.module.scss';
import icStatHealth from 'assets/svg/ic_stat_heart.svg';
import icStatDamage from 'assets/svg/ic_stat_sword.svg';
import icStatAttSpd from 'assets/svg/ic_stat_sword_2.svg';
import icStatSpd from 'assets/svg/ic_stat_speed.svg';

const StatsPanel = ({
  item,
  description
}) => {
  const stats = React.useMemo(() => [{
    icon: icStatHealth,
    label: 'HEALTH',
    value: item.heroType.hp
  }, {
    icon: icStatDamage,
    label: 'DAMAGE',
    value: item.heroType.dmg
  }, {
    icon: icStatAttSpd,
    label: 'ATT. SPD.',
    value: item.heroType.attackSpeed
  }, {
    icon: icStatSpd,
    label: 'SPEED',
    value: item.heroType.speed
  }], [item]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, description === null || description === void 0 ? void 0 : description.description), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapList
  }, stats.map(e => /*#__PURE__*/React.createElement("div", {
    key: e.label,
    className: styles.item
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, e.label), /*#__PURE__*/React.createElement("div", {
    className: styles.rowValue
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapIcon
  }, /*#__PURE__*/React.createElement("img", {
    src: e.icon,
    className: styles.icon
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, e.value))))));
};

export default StatsPanel;